import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepLinkedFilesFormContainer from '../../../../containers/projects/ChangeStrategyFormContainers/StepLinkedFilesFormContainer.jsx';

const NewChangeStrategyStepLinkedFiles = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Change Strategy | ChangeSync</title>
    </Helmet>
    <StepLinkedFilesFormContainer projectId={projectId} slug={slug} />
  </>
);

NewChangeStrategyStepLinkedFiles.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(NewChangeStrategyStepLinkedFiles));
